// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminQuotes = (client) => ({
    /**
     * `POST /admin/quotes/:id/messages`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/quotes/[id]/messages/route.ts
     */
    createMessage: (id, body, query, headers) => client.fetch(buildPath("/admin/quotes/:id/messages", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/quotes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/quotes/route.ts
     */
    list: (query, headers) => client.fetch("/admin/quotes", { method: "GET", query, headers }),
    /**
     * `POST /admin/quotes/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/quotes/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/admin/quotes/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/quotes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/quotes/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/quotes/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/quotes/:id/send`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/quotes/[id]/send/route.ts
     */
    send: (id, body, query, headers) => client.fetch(buildPath("/admin/quotes/:id/send", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=quotes.js.map